'use strict'

import {
  buildPropFieldResolvers
} from './portal-editors-props.js'

const createPortalPropRuntime = function (PORTAL_PRESETS, {
  _,
  fnT,
  fnTF,
  fnResolveI18Text,
  pathWithoutLeadingScope,
  pathWithoutNumericParts,
  getPathLeafField
}) {
  const portalPresetsRuntime = (PORTAL_PRESETS.runtime && typeof PORTAL_PRESETS.runtime === 'object')
    ? PORTAL_PRESETS.runtime
    : {}
  const propFieldValuePresets = (PORTAL_PRESETS.valuePresetsByPath && typeof PORTAL_PRESETS.valuePresetsByPath === 'object')
    ? PORTAL_PRESETS.valuePresetsByPath
    : {}
  const propFieldDisableRules = Array.isArray(portalPresetsRuntime.fieldDisableRules)
    ? portalPresetsRuntime.fieldDisableRules
    : []
  const altitudeRules = (PORTAL_PRESETS.altitudeRules && typeof PORTAL_PRESETS.altitudeRules === 'object')
    ? PORTAL_PRESETS.altitudeRules
    : {}
  const pointAltitudeModeValues = (propFieldValuePresets['Point.altitudeMode'] || []).map((item) => item.value)

  const fieldResolvers = buildPropFieldResolvers(PORTAL_PRESETS, {
    _,
    fnT,
    fnTF,
    fnResolveI18Text,
    pathWithoutLeadingScope,
    pathWithoutNumericParts,
    getPathLeafField
  })

  return {
    propFieldDisableRules,
    altitudeRules,
    pointAltitudeModeValues,
    ...fieldResolvers
  }
}

const buildRenderPropEditorRowsDeps = function ({
  _,
  $,
  fnT,
  NON_EXPORT_PROJECT_FILENAME_PATH,
  NON_EXPORT_POINT_HEIGHT_PATH,
  DEM_PROVIDER_PRIORITY,
  fnGetDemProviderLabel,
  fnRunPointHeightDemOverwriteFlow,
  fnGetPointHeightToolFieldMeta,
  fnGetPointNumericByPathAliases,
  toFiniteNumber,
  pathWithoutNamespacePrefixes,
  pathWithoutNumericParts,
  fnResolvePropPresetOptions,
  getPathLeafField,
  pathWithoutLeadingScope,
  fnResolvePropLabelTooltip,
  fnResolvePropLabelDetailedHelp,
  fnResolvePropLabelIconClass,
  fnResolvePropLabelRequired,
  fnBuildHeadingSuggestModel,
  toUnixMs,
  fnFormatUnixMsForDisplay,
  fnParseDisplayTimestampToUnixMs,
  TIMESTAMP_DISPLAY_FORMAT,
  fnResolveI18Text,
  fnResolvePropValueHelp,
  fnShowPropContextMenu,
  PROP_FIELD_DISABLE_RULES
}) {
  return {
    _: _,
    $: $,
    fnT: fnT,
    NON_EXPORT_PROJECT_FILENAME_PATH: NON_EXPORT_PROJECT_FILENAME_PATH,
    NON_EXPORT_POINT_HEIGHT_PATH: NON_EXPORT_POINT_HEIGHT_PATH,
    DEM_PROVIDER_PRIORITY: DEM_PROVIDER_PRIORITY,
    fnGetDemProviderLabel: fnGetDemProviderLabel,
    fnRunPointHeightDemOverwriteFlow: fnRunPointHeightDemOverwriteFlow,
    fnGetPointHeightToolFieldMeta: fnGetPointHeightToolFieldMeta,
    fnGetPointNumericByPathAliases: fnGetPointNumericByPathAliases,
    toFiniteNumber: toFiniteNumber,
    pathWithoutNamespacePrefixes: pathWithoutNamespacePrefixes,
    pathWithoutNumericParts: pathWithoutNumericParts,
    fnResolvePropPresetOptions: fnResolvePropPresetOptions,
    getPathLeafField: getPathLeafField,
    pathWithoutLeadingScope: pathWithoutLeadingScope,
    fnResolvePropLabelTooltip: fnResolvePropLabelTooltip,
    fnResolvePropLabelDetailedHelp: fnResolvePropLabelDetailedHelp,
    fnResolvePropLabelIconClass: fnResolvePropLabelIconClass,
    fnResolvePropLabelRequired: fnResolvePropLabelRequired,
    fnBuildHeadingSuggestModel: fnBuildHeadingSuggestModel,
    toUnixMs: toUnixMs,
    fnFormatUnixMsForDisplay: fnFormatUnixMsForDisplay,
    fnParseDisplayTimestampToUnixMs: fnParseDisplayTimestampToUnixMs,
    TIMESTAMP_DISPLAY_FORMAT: TIMESTAMP_DISPLAY_FORMAT,
    fnResolveI18Text: fnResolveI18Text,
    fnResolvePropValueHelp: fnResolvePropValueHelp,
    fnShowPropContextMenu: fnShowPropContextMenu,
    PROP_FIELD_DISABLE_RULES: PROP_FIELD_DISABLE_RULES
  }
}

const buildPointEditLauncherOptions = function ({
  _,
  $,
  areaSwal,
  drawnItems,
  fnT,
  fnTF,
  importMissionType,
  importMissionState,
  NON_EXPORT_PROJECT_FILENAME_PATH,
  NON_EXPORT_POINT_HEIGHT_PATH,
  DEM_PROVIDER_PRIORITY,
  fnGetDemProviderLabel,
  fnRunPointHeightDemOverwriteFlow,
  fnGetPointHeightToolFieldMeta,
  POINT_ELLIPSOID_HEIGHT_PATH_ALIASES,
  fnCaptureState,
  fnHistoryPush,
  fnAttachSeekAxisLayerToModal,
  fnGetTemplateWaypointDefaults,
  fnTemplateSupportsPointCoordinatesField,
  fnPropsToMap,
  fnSortPointEditorRows,
  fnPropsMapToRows,
  fnFilterPointEditorMapForMissionType,
  fnIsKmlActionPath,
  fnIsKmzActionPath,
  fnSetByPath,
  fnUpdatePointXmlByPath,
  fnSyncPointActionFileSuffixWithNameWithContext,
  fnIsWaypointHeightPath,
  fnGetMissionAltitudeContextFor3d,
  fnRecalculateEgm96EllipsoidForPoints,
  fnGetPointNumericByPathAliases,
  fnIsEllipsoidHeightPath,
  fnBuildPointCoordinatesText,
  fnUpdatePointCoordinates,
  fnSyncRoute3dSharedState,
  fnScheduleRoute3dSharedSync,
  fnRefreshWaypointMarker,
  fnGetKmlActionsFromProps,
  fnSetKmlActionsInProps,
  fnSetPointKmlActionsWithContext,
  fnApplyKmzActionFileSuffixDisplayModeToGroups,
  fnGetKmzActionGroupsFromProps,
  fnGetPointName,
  fnResolveKmzActionFileSuffixPointNameTokensInGroups,
  fnSetKmzActionGroupsInProps,
  fnSetPointKmzActionGroupsWithContext,
  fnMergePropsForEdit,
  fnApplyEditsToPoints,
  fnBuildSharedKmlActionsForPoints,
  fnBuildSharedKmzActionGroupsForPoints,
  toFiniteNumber,
  pathWithoutNamespacePrefixes,
  pathWithoutNumericParts,
  fnResolvePropPresetOptions,
  getPathLeafField,
  pathWithoutLeadingScope,
  fnResolvePropLabelTooltip,
  fnResolvePropLabelDetailedHelp,
  fnResolvePropLabelIconClass,
  fnResolvePropLabelRequired,
  fnBuildHeadingSuggestModel,
  toUnixMs,
  fnFormatUnixMsForDisplay,
  fnParseDisplayTimestampToUnixMs,
  TIMESTAMP_DISPLAY_FORMAT,
  fnResolveI18Text,
  fnResolvePropValueHelp,
  fnShowPropContextMenu,
  PROP_FIELD_DISABLE_RULES
}) {
  return {
    _: _,
    $: $,
    areaSwal: areaSwal,
    drawnItems: drawnItems,
    fnT: fnT,
    fnTF: fnTF,
    importMissionType: importMissionType,
    importMissionState: importMissionState,
    NON_EXPORT_PROJECT_FILENAME_PATH: NON_EXPORT_PROJECT_FILENAME_PATH,
    NON_EXPORT_POINT_HEIGHT_PATH: NON_EXPORT_POINT_HEIGHT_PATH,
    DEM_PROVIDER_PRIORITY: DEM_PROVIDER_PRIORITY,
    fnGetDemProviderLabel: fnGetDemProviderLabel,
    fnRunPointHeightDemOverwriteFlow: fnRunPointHeightDemOverwriteFlow,
    fnGetPointHeightToolFieldMeta: fnGetPointHeightToolFieldMeta,
    POINT_ELLIPSOID_HEIGHT_PATH_ALIASES: POINT_ELLIPSOID_HEIGHT_PATH_ALIASES,
    fnCaptureState: fnCaptureState,
    fnHistoryPush: fnHistoryPush,
    fnAttachSeekAxisLayerToModal: fnAttachSeekAxisLayerToModal,
    fnGetTemplateWaypointDefaults: fnGetTemplateWaypointDefaults,
    fnTemplateSupportsPointCoordinatesField: fnTemplateSupportsPointCoordinatesField,
    fnPropsToMap: fnPropsToMap,
    fnSortPointEditorRows: fnSortPointEditorRows,
    fnPropsMapToRows: fnPropsMapToRows,
    fnFilterPointEditorMapForMissionType: fnFilterPointEditorMapForMissionType,
    fnIsKmlActionPath: fnIsKmlActionPath,
    fnIsKmzActionPath: fnIsKmzActionPath,
    fnSetByPath: fnSetByPath,
    fnUpdatePointXmlByPath: fnUpdatePointXmlByPath,
    fnSyncPointActionFileSuffixWithNameWithContext: fnSyncPointActionFileSuffixWithNameWithContext,
    fnIsWaypointHeightPath: fnIsWaypointHeightPath,
    fnGetMissionAltitudeContextFor3d: fnGetMissionAltitudeContextFor3d,
    fnRecalculateEgm96EllipsoidForPoints: fnRecalculateEgm96EllipsoidForPoints,
    fnGetPointNumericByPathAliases: fnGetPointNumericByPathAliases,
    fnIsEllipsoidHeightPath: fnIsEllipsoidHeightPath,
    fnBuildPointCoordinatesText: fnBuildPointCoordinatesText,
    fnUpdatePointCoordinates: fnUpdatePointCoordinates,
    fnSyncRoute3dSharedState: fnSyncRoute3dSharedState,
    fnScheduleRoute3dSharedSync: fnScheduleRoute3dSharedSync,
    fnRefreshWaypointMarker: fnRefreshWaypointMarker,
    fnGetKmlActionsFromProps: fnGetKmlActionsFromProps,
    fnSetKmlActionsInProps: fnSetKmlActionsInProps,
    fnSetPointKmlActionsWithContext: fnSetPointKmlActionsWithContext,
    fnApplyKmzActionFileSuffixDisplayModeToGroups: fnApplyKmzActionFileSuffixDisplayModeToGroups,
    fnGetKmzActionGroupsFromProps: fnGetKmzActionGroupsFromProps,
    fnGetPointName: fnGetPointName,
    fnResolveKmzActionFileSuffixPointNameTokensInGroups: fnResolveKmzActionFileSuffixPointNameTokensInGroups,
    fnSetKmzActionGroupsInProps: fnSetKmzActionGroupsInProps,
    fnSetPointKmzActionGroupsWithContext: fnSetPointKmzActionGroupsWithContext,
    fnMergePropsForEdit: fnMergePropsForEdit,
    fnApplyEditsToPoints: fnApplyEditsToPoints,
    fnBuildSharedKmlActionsForPoints: fnBuildSharedKmlActionsForPoints,
    fnBuildSharedKmzActionGroupsForPoints: fnBuildSharedKmzActionGroupsForPoints,
    toFiniteNumber: toFiniteNumber,
    pathWithoutNamespacePrefixes: pathWithoutNamespacePrefixes,
    pathWithoutNumericParts: pathWithoutNumericParts,
    fnResolvePropPresetOptions: fnResolvePropPresetOptions,
    getPathLeafField: getPathLeafField,
    pathWithoutLeadingScope: pathWithoutLeadingScope,
    fnResolvePropLabelTooltip: fnResolvePropLabelTooltip,
    fnResolvePropLabelDetailedHelp: fnResolvePropLabelDetailedHelp,
    fnResolvePropLabelIconClass: fnResolvePropLabelIconClass,
    fnResolvePropLabelRequired: fnResolvePropLabelRequired,
    fnBuildHeadingSuggestModel: fnBuildHeadingSuggestModel,
    toUnixMs: toUnixMs,
    fnFormatUnixMsForDisplay: fnFormatUnixMsForDisplay,
    fnParseDisplayTimestampToUnixMs: fnParseDisplayTimestampToUnixMs,
    TIMESTAMP_DISPLAY_FORMAT: TIMESTAMP_DISPLAY_FORMAT,
    fnResolveI18Text: fnResolveI18Text,
    fnResolvePropValueHelp: fnResolvePropValueHelp,
    fnShowPropContextMenu: fnShowPropContextMenu,
    PROP_FIELD_DISABLE_RULES: PROP_FIELD_DISABLE_RULES
  }
}

export {
  createPortalPropRuntime,
  buildRenderPropEditorRowsDeps,
  buildPointEditLauncherOptions
}
